import EmotionName, { EmotionNameProps } from './EmotionName'

export default function EmotionDescription(props: EmotionNameProps) {
  return <EmotionName transKey="description" {...props} />
}
